export class RouteConstants {
  static HOME: string = '/'
}
